import cartSlice from "./slice";

import { updateItemsQuantities } from "./actions/updateItemsQuantities";

import {
  selectCartItems,
  selectIsCartOpen,
  selectTotalPrice,
  selectIsCartLoaded,
  selectOldTotalPrice,
} from "./selectors";

export default cartSlice.reducer;

export const {
  addToCart,
  closeCart,
  updateCartItem,
  getItemsFromLocalStorage,
  hydrateSharedCart,
  openCart,
  removeFromCart,
  toggleCart,
  clearCart,
} = cartSlice.actions;

export {
  selectCartItems,
  selectIsCartOpen,
  selectTotalPrice,
  selectIsCartLoaded,
  selectOldTotalPrice,
  updateItemsQuantities,
};
